export const MediumList = [
  {
    articlephoto: "/assets/imgs/medium1.png",
    articletitle: "A Brief Introduction to Test-Driven Development(TDD)",
    readingtime: "9 min read",
    previewtext:
      "Test Driven Development (TDD) is a software development process in which the test cases are written before writing the code…",
    link: "https://medium.com/readytowork-org/a-brief-introduction-to-test-driven-development-tdd-71a22b5b2887",

    username: "Pratik Adhikari",
    releasedate: "Apr 10",
  },
  {
    articlephoto: "/assets/imgs/medium2.png",
    articletitle: "Build A Multiplayer Game In Go",
    readingtime: "14 min read",
    previewtext:
      "In this article, we will be building a paddle game that can be played by two players at once. Previously…",
    link: "https://medium.com/readytowork-org/build-a-multiplayer-game-in-go-5d07442fbde2",

    username: "Simant Thapa Magar",
    releasedate: "May 5",
  },
  {
    articlephoto: "/assets/imgs/medium3.png",
    articletitle: "Microservices in Gin Golang",
    readingtime: "6 min read",
    previewtext:
      "Before we start, this is one of the practice sessions. And you might need a computer with a basic Go-Gin application…",
    link: "https://medium.com/readytowork-org/microservice-in-gin-golang-91851930036a",

    username: "Sagar Shrestha",
    releasedate: "May 2",
  },
  {
    articlephoto: "/assets/imgs/medium4.png",
    articletitle: "Streamlining Your Website Deployment",
    readingtime: "5 min read",
    previewtext:
      "In today’s fast-paced digital world, having a website that loads quickly and reliably is crucial for businesses and individuals…",
    link: "https://medium.com/readytowork-org/streamlining-your-website-deployment-how-to-host-a-static-website-on-aws-s3-and-automate-ci-cd-84955a444104",

    username: "Kshitiz Shrestha",
    releasedate: "Apr 30",
  },
  {
    articlephoto: "/assets/imgs/medium5.png",
    articletitle: "GeoFencing in React Native",
    readingtime: "5 min read",
    previewtext:
      "Geo-fence is a location-based technology that creates a virtual boundary around a physical location or area, such as a store…",
    link: "https://medium.com/readytowork-org/geofencing-in-react-native-4d8cf42fe90c",

    username: "Dipesh Koirala",
    releasedate: "24 Mar",
  },
]
